import {BaseProbVariables} from "@/modules/lcca/interfaces/probabilistic";
import {ILccaCalculated, ILccaCalculatedImperial} from "@/modules/lcca/interfaces/lccaCalculated";
import {IDistribution} from "@/lib/monteCarlo/interfaces";

export const getProbabilisticByName = function(probList: IDistribution[], name: string): IDistribution {
  return probList.filter(P => P.name === name)[0]
};


export const getUserProbInputs = function(scenarioImperial: ILccaCalculatedImperial){
  const P = [
    BaseProbVariables.passengerCarsTime,
    BaseProbVariables.singleUnitTrucksTime,
    BaseProbVariables.combinationTrucksTime
  ];

  const distMap : {[index:string]: IDistribution} = {};

  P.forEach(pName => distMap[pName] = getProbabilisticByName(scenarioImperial.probabilistic, pName));

  return distMap
};
